import { LeaderboardData, LeaderboardTableRow, Standing } from '@/types/dde/golfLeaderboard.types'
import logger from '@/utils/_legacy/logger'

export const transformLeaderboardDataToRows = (
  leaderboardData: LeaderboardData
): LeaderboardTableRow[] => {
  if (!leaderboardData?.standings || !Array.isArray(leaderboardData.standings)) {
    return []
  }

  const tournamentId = leaderboardData.tournamentId ?? 0

  return leaderboardData.standings
    .filter((standing) => standing?.status !== 'Removed')
    .map((standing) => {
      try {
        return transformStandingToRow(standing, tournamentId)
      } catch (error) {
        logger.error(error, 'Failed to transform standing')
        return null
      }
    })
    .filter((row): row is LeaderboardTableRow => row !== null)
    .sort((a, b) => (a.positionOrder ?? 0) - (b.positionOrder ?? 0))
}

const transformStandingToRow = (standing: Standing, tournamentId: number): LeaderboardTableRow => {
  const roundInfo = standing?.roundInfo ?? {}

  const round1 = getRoundScore(roundInfo, '1')
  const round2 = getRoundScore(roundInfo, '2')
  const round3 = getRoundScore(roundInfo, '3')
  const round4 = getRoundScore(roundInfo, '4')

  return {
    id: `${tournamentId}-${standing?.teamNo ?? 0}`,
    tournamentId,
    teamNo: standing?.teamNo ?? 0,
    position: standing?.position?.displayValue ?? '-',
    positionOrder: standing?.position?.order ?? 999,
    positionFormat: standing?.position?.format ?? 'absolute',
    players: Array.isArray(standing?.players) ? standing.players : [],
    toPar: standing?.toPar?.value ?? 0,
    toParDisplay: standing?.toPar?.displayValue ?? '-',
    hole: standing?.holesThrough?.displayValue ?? '-',
    toParToday: standing?.toParToday?.value ?? 0,
    toParTodayDisplay: standing?.toParToday?.displayValue ?? '-',
    round1: round1.score,
    round1ToPar: round1.toPar,
    round2: round2.score,
    round2ToPar: round2.toPar,
    round3: round3.score,
    round3ToPar: round3.toPar,
    round4: round4.score,
    round4ToPar: round4.toPar,
    total: standing?.totalScore?.displayValue ?? '-',
    status: standing?.status ?? 'Unknown',
    rawStanding: standing
  }
}

const getRoundScore = (
  roundInfo: Standing['roundInfo'],
  roundNumber: string
): { score: string; toPar: number } => {
  const round = roundInfo?.[roundNumber]
  if (!round) {
    return { score: '-', toPar: 0 }
  }
  return {
    score: round?.score?.displayValue ?? '-',
    toPar: round?.toPar?.value ?? 0
  }
}
